import React, { useEffect, useRef } from "react";
import Typed from "typed.js";
import { useNavigate } from "react-router-dom";
import "../styles/global.css";


const dishes = [
  {
    name: "Paneer Butter Masala",
    image: "/images/paneer.jpg",
    price: "₹250",
    offer: "20% OFF",
  },
  {
    name: "Veg Biryani",
    image: "/images/vegbiriyani.jpeg",
    price: "₹180",
    offer: "10% OFF",
  },
  {
    name: "Chicken Tikka",
    image: "/images/tikka.jpeg",
    price: "₹320",
    offer: "15% OFF",
  },
  {
    name: "Chocolate Lava Cake",
    image: "/images/lavacake.jpeg",
    price: "₹120",
    offer: "25% OFF",
  },
];

function Home() {
  const typedRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const typed = new Typed(typedRef.current, {
      strings: ["The Tasty Dine"],
      typeSpeed: 60,
      backSpeed: 30,
      loop: true,
      backDelay: 2000,
      showCursor: false,
    });

    return () => {
      typed.destroy();
    };
  }, []);

  return (
    <>
      {/* HERO SECTION */}
      <div
        className="hero-container"
        style={{
          position: "relative",
          textAlign: "center",
          height: "70vh",
          overflow: "hidden",
        }}
        id="home"
      >
        <img
          src="/images/photo.avif"
          alt="Delicious food"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            filter: "brightness(60%)",
          }}
        />

        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              fontStyle: "italic",
            }}
          >
            <span ref={typedRef}></span>
          </h1>
          <p
            style={{
              fontSize: "1.2rem",
              marginTop: "1rem",
              fontStyle: "italic",
            }}
          >
            Where Every Bite Tells a Delicious Story
          </p>
        </div>
      </div>
        <div className="about-wrapper" id="about">
      {/* Center content */}
      <div className="about-center">
        <img src="/images/flow.jpg" alt="about" className="about-image" />
        <h1>Welcome To The Tasty Dine</h1>
      </div>

      {/* Animated left and right columns */}
      <div className="about-columns">
        <div className="about-column slide-in-left">
          <p>
            Welcome to <strong>The Tasty Dine</strong>, where every dish is crafted with
            passion and plated with perfection. Located in the heart of the city,
            we blend authentic flavors with a modern dining experience that brings
            people together over delicious meals.
          </p>
          <p>
            Our chefs use only the freshest ingredients, handpicked daily to create
            a menu full of flavor and variety — from traditional classics to
            exciting new dishes.
          </p>
        </div>
        <div className="about-column slide-in-right">
          <p>
            Whether you're looking for a cozy dinner, a family lunch, or a place
            to celebrate a special moment, <strong>The Tasty Dine</strong> welcomes
            you with warmth and flavor.
          </p>
          <p>
            At The Tasty Dine, it's not just about food — it's about the memories
            you create around it. Come taste the difference. Come experience a story
            told one bite at a time.
          </p>
        </div>
      </div>
    </div>
      {/* POPULAR DISHES SECTION */}
      <div style={styles.container}>
        <h2 style={styles.title}>🍽️ Our Popular Dishes</h2>
        <div style={styles.grid}>
          {dishes.map((dish, index) => (
            <div key={index} style={styles.card} >
              <img src={dish.image} alt={dish.name} style={styles.image} />
              <h3 style={styles.name}>{dish.name}</h3>
              <p style={styles.price}>{dish.price}</p>
              <p className="blink-text">{dish.offer}</p>
            </div>
          ))}
        </div>

        <div className="waiter-section">
          <img
            src="/images/waiter.png"
            alt="Waiter holding plate"
            className="waiter-img"
          />
          <button
            className="plate-button"
            onClick={() => navigate("/menu")}
          >
            View Full Menu
          </button>
        </div>
      </div>
      <div className="contact-us" id="contact">
  <h1>Contact Us</h1>
  <p>Email: info@thetastydine.com</p>
  <p>Phone: +91 9876543210</p>
  <p>Address: 123 Main Street, Karnataka, India</p>
</div>

    </>
  );
}

const styles = {
  container: {
    padding: "2rem",
    textAlign: "center",
    backgroundColor: "#fff7f2",
  },
  title: {
    fontSize: "2rem",
    marginBottom: "2rem",
    color: "#d9534f",
  },
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "1.5rem",
  },
  card: {
    backgroundColor: "#fff",
    borderRadius: "10px",
    padding: "1rem",
    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
    transition: "transform 0.3s ease",
  },


  image: {
    width: "100%",
    height: "180px",
    objectFit: "cover",
    borderRadius: "8px",
  },
  name: {
    fontSize: "1.2rem",
    margin: "0.5rem 0",
  },
  price: {
    fontWeight: "bold",
    color: "#333",
  },
};

export default Home;
